// 管理画面の「ログイン状態」ズレを自己修復するためのガード。
//
// 背景:
//   フロントの「ログイン中」は localStorage の isLoggedIn フラグで判定しており、
//   バックエンドの実セッション（sessionid Cookie）とは独立している。Cookie が
//   失効/未送信でも UI は「ログイン中」に見えるため、request.user を必要とする
//   給与明細アップロードだけが分かりにくいエラー（Instructor.id が解決できません）で
//   失敗していた。
//
// 方針:
//   管理API（REACT_APP_API_URL 配下の /api/）が 401 を返したら＝実セッション失効と
//   みなし、localStorage の認証フラグを消して /login?session=expired へ誘導する。
//   生の fetch を多数の画面が直接使っているため、共通ラッパを各所へ差し込むのではなく
//   window.fetch を起動時に一度だけラップして横断的に検知する。
//
// 誤発火の防止:
//   - 対象は「管理APIと同一オリジンの /api/ パス」のみ。slash-app（チャット）の API は
//     別オリジン・別のトークン更新フローを持つため、ここで横取りしない。
//   - ログインAPI自体は認証失敗時に 400 を返す（401 ではない）ため、ログイン誤入力で
//     再ログインループにはならない。
//   - /login 上での 401 では遷移しない（ループ防止）。

const ADMIN_API_BASE = process.env.REACT_APP_API_URL || "";

let handling = false;

function isAdminApiUrl(input) {
  try {
    const raw =
      typeof input === "string"
        ? input
        : input && typeof input.url === "string"
        ? input.url
        : "";
    if (!raw) return false;
    const abs = new URL(raw, window.location.origin);
    const base = ADMIN_API_BASE
      ? new URL(ADMIN_API_BASE, window.location.origin)
      : new URL(window.location.origin);
    return abs.origin === base.origin && abs.pathname.startsWith("/api/");
  } catch (e) {
    return false;
  }
}

function handleExpired() {
  if (handling) return; // 多重リクエストで何度も遷移しないように一度だけ
  handling = true;
  try {
    localStorage.removeItem("isLoggedIn");
    // slash-app（チャット）用の JWT も、再ログインで取り直すためクリア（logout() と同じ挙動）
    localStorage.removeItem("slashapp_access");
    localStorage.removeItem("slashapp_refresh");
    localStorage.removeItem("slashapp_sub_id");
  } catch (e) {
    /* localStorage 不可環境は無視 */
  }
  const path = window.location.pathname || "";
  if (!path.endsWith("/login") && path !== "/login") {
    window.location.href = "/login?session=expired";
  }
}

export function installSessionGuard() {
  if (typeof window === "undefined" || !window.fetch) return;
  if (window.__adminSessionGuardInstalled) return;
  window.__adminSessionGuardInstalled = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const res = await originalFetch(input, init);
    try {
      if (res && res.status === 401 && isAdminApiUrl(input)) {
        handleExpired();
      }
    } catch (e) {
      /* 監視は best-effort。失敗しても元のレスポンスはそのまま返す */
    }
    return res;
  };
}
